import React from "react";

const Logos = () => {
  return (
    <div className="container mt-3 mb-2">
      <div className="text-center mb-1">
        <span className="section-badge">Our Industries</span>
      </div>
      <div className="logos">
        <div className="logos-slide mb-5">
          <img src="/img/logo/Bharathi.jpeg" alt="Bharathi Logo" />
          <img src="/img/logo/chintamani.jpeg" alt="Chintamani Logo" />
          <img src="/img/logo/gubbaCold.jpg" alt="Gubba Cold Logo" />
          <img src="/img/logo/Impression.png" alt="Impression Logo" />
          <img src="/img/logo/murr.png" alt="Murr Logo" />
          <img src="/img/logo/neotric.jpg" alt="Neotric Logo" />
          <img src="/img/logo/opel.jpg" alt="Opel Logo" />
          <img src="/img/logo/tedra.jpg" alt="Tedra Logo" />
          <img src="/img/logo/ultra.png" alt="Ultra Logo" />
          <img src="/img/logo/United.jpg" alt="United Logo" />
          <img src="/img/logo/crysta.png" alt="crysta Logo" />
          <img src="/img/logo/Rajdeep.png" alt="Rajdeep Logo" />
          <img src="/img/logo/EZ.png" alt="EZ Logo" />
          <img src="/img/logo/concord.png" alt="concord Logo" />
          
          <img src="/img/logo/Bharathi.jpeg" alt="Bharathi Logo" />
          <img src="/img/logo/chintamani.jpeg" alt="Chintamani Logo" />
          <img src="/img/logo/gubbaCold.jpg" alt="Gubba Cold Logo" />
          <img src="/img/logo/Impression.png" alt="Impression Logo" />
          <img src="/img/logo/murr.png" alt="Murr Logo" />
          <img src="/img/logo/neotric.jpg" alt="Neotric Logo" />
          <img src="/img/logo/opel.jpg" alt="Opel Logo" />
          <img src="/img/logo/tedra.jpg" alt="Tedra Logo" />
          <img src="/img/logo/ultra.png" alt="Ultra Logo" />
          <img src="/img/logo/United.jpg" alt="United Logo" />
          <img src="/img/logo/crysta.png" alt="crysta Logo" />
          <img src="/img/logo/Rajdeep.png" alt="Rajdeep Logo" />
          <img src="/img/logo/EZ.png" alt="EZ Logo"/>
          <img src="/img/logo/concord.png" alt="concord Logo" />
        </div>
      </div>
    </div>
  );
};

export default Logos;